import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React, { ReactNode } from 'react';

import { BUGSNAG_API_KEY } from 'global';

export const BugsnagWrapper = ({ children }: { children: ReactNode }) => {
  if (!BUGSNAG_API_KEY) {
    return <>{children}</>;
  }

  Bugsnag.start({
    apiKey: BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
  });

  BugsnagPerformance.start({ apiKey: BUGSNAG_API_KEY });

  const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

  return <ErrorBoundary>{children}</ErrorBoundary>;
};
